import { DialogRow } from "../../primitives/DialogContent";
import { InfoIcon } from "@100mslive/react-icons";
import { Text } from "@100mslive/react-ui";
import { isChrome } from "../../common/constants";

export const PDFInfo = () => {
  if (!isChrome) {
    return null;
  }

  return (
    <DialogRow
      css={{
        p: "$8",
        bg: "$surfaceLight",
        r: "$1",
        outline: "none",
        border: "1px solid $borderLight",
        mt: "$0",
      }}
    >
      <InfoIcon
        height={20}
        width={20}
        style={{
          marginRight: "16px",
          minWidth: "20px",
        }}
      />
      <Text variant="caption" css={{ color: "$textMedEmp" }}>
        Trên màn hình tiếp theo, đảm bảo bạn chọn{" "}
        <span style={{ fontWeight: "600" }}>“Tab này”</span> và nhấp vào{" "}
        <span style={{ fontWeight: "600" }}>“Chia sẻ” </span>
      </Text>
    </DialogRow>
  );
};
